<template>

	<div>

		<el-row>
            <el-col :span="24">
                <p class="comfy-text s-16">Verifica que los datos de tu servicio sean correctos y procede con la autorización del pago:</p>
            </el-col>
        </el-row>

        <el-row class="mb-3">
            <el-divider content-position="center">Datos PRO</el-divider>
        </el-row>

        <el-row v-if="servicio.terapistaUno" class="mb-3" :gutter="20">

            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <vs-avatar size="80" circle history history-gradient badge badge-color="primary">
                    <img :src="url + servicio.terapistaUno.foto">
                    <template #badge v-if="showPerfil">
						<span @click="openProfile(servicio.terapistaUno.id)" class="cursor-pointer">
                            Ver perfil
                        </span>
					</template>
                </vs-avatar>
            </el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
                <b>Nombre:</b> {{ servicio.terapistaUno.nombre }}<br>
				<b>Servicio:</b> {{ masajeUno }}<br>
				<b>Duración:</b> {{ servicio.duracion }} minutos<br>
				<b>Tipo:</b> {{ servicioTipoNombre }}
            </el-col>
            <el-col :span="24" class="mt-2">
                <el-row class="mb-3">
					<el-col :span="2">
						<vs-checkbox color="#123b5a" v-model="tyc" val="masajeUno">
						</vs-checkbox>
					</el-col>
					<el-col :span="22">
                        Conozco y acepto <a class="font-weight-normal" target="_blank" :href="urlTyc">TyC</a> de servicios de masajes reservados a domicilio.
					</el-col>
				</el-row>
                <el-divider v-if="servicio.terapistaDos"></el-divider>
            </el-col>

        </el-row>

        <el-row v-if="servicio.terapistaDos" class="mb-3" :gutter="20">

            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" class="text-right">
                <b>Nombre:</b> {{ servicio.terapistaDos.nombre }}<br>
                <b>Servicio:</b> {{ masajeDos }}<br>
                <b>Duración:</b> {{ servicio.duracion }} minutos<br>
                <b>Tipo:</b> {{ servicioTipoNombre }}
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="text-right">
                <vs-avatar size="80" circle history history-gradient badge badge-color="primary" class="avatar-right">
                    <img :src="url + servicio.terapistaDos.foto">
                    <template #badge v-if="showPerfil">
						<span @click="openProfile(servicio.terapistaDos.id)" class="cursor-pointer">
                            Ver perfil
                        </span>
					</template>
                </vs-avatar>
            </el-col>
            <el-col :span="24" class="mt-2">
                <el-row class="mb-3">
					<el-col :span="2">
						<vs-checkbox color="#123b5a" v-model="tyc" val="masajeDos">
						</vs-checkbox>
					</el-col>
					<el-col :span="22">
                        Conozco y acepto <a class="font-weight-normal" target="_blank" :href="urlTyc">TyC</a> de servicios de masajes reservados a domicilio.
					</el-col>
				</el-row>
                <el-divider v-if="servicio.terapistaTres"></el-divider>
            </el-col>

        </el-row>

        <el-row v-if="servicio.terapistaTres" class="mb-3" :gutter="20">

            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <vs-avatar size="80" circle history history-gradient badge badge-color="primary">
                    <img :src="url + servicio.terapistaTres.foto">
                    <template #badge v-if="showPerfil">
						<span @click="openProfile(servicio.terapistaTres.id)" class="cursor-pointer">
                            Ver perfil
                        </span>
					</template>
                </vs-avatar>
            </el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
                <b>Nombre:</b> {{ servicio.terapistaTres.nombre }}<br>
                <b>Servicio:</b> {{ masajeTres }}<br>
                <b>Duración:</b> {{ servicio.duracion }} minutos<br>
                <b>Tipo:</b> {{ servicioTipoNombre }}
            </el-col>
            <el-col :span="24" class="mt-2">
                <el-row class="mb-3">
					<el-col :span="2">
						<vs-checkbox color="#123b5a" v-model="tyc" val="masajeTres">
						</vs-checkbox>
					</el-col>
					<el-col :span="22">
                        Conozco y acepto <a class="font-weight-normal" target="_blank" :href="urlTyc">TyC</a> de servicios de masajes reservados a domicilio.
					</el-col>
				</el-row>
                <el-divider v-if="servicio.terapistaCuatro"></el-divider>
            </el-col>

        </el-row>

        <el-row v-if="servicio.terapistaCuatro" class="mb-3" :gutter="20">

            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" class="text-right">
                <b>Nombre:</b> {{ servicio.terapistaCuatro.nombre }}<br>
                <b>Servicio:</b> {{ masajeCuatro }}<br>
                <b>Duración:</b> {{ servicio.duracion }} minutos<br>
                <b>Tipo:</b> {{ servicioTipoNombre }}
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="text-right">
                <vs-avatar size="80" circle history history-gradient badge badge-color="primary" class="avatar-right">
                    <img :src="url + servicio.terapistaCuatro.foto">
                    <template #badge v-if="showPerfil">
						<span @click="openProfile(servicio.terapistaCuatro.id)" class="cursor-pointer">
                            Ver perfil
                        </span>
					</template>
                </vs-avatar>
            </el-col>
            <el-col :span="24" class="mt-2">
                <el-row class="mb-3">
					<el-col :span="2">
						<vs-checkbox color="#123b5a" v-model="tyc" val="masajeCuatro">
						</vs-checkbox>
					</el-col>
					<el-col :span="22">
                        Conozco y acepto <a class="font-weight-normal" target="_blank" :href="urlTyc">TyC</a> de servicios de masajes reservados a domicilio.
					</el-col>
				</el-row>
                <el-divider v-if="servicio.terapistaCinco"></el-divider>
            </el-col>

        </el-row>

        <el-row v-if="servicio.terapistaCinco" class="mb-3" :gutter="20">

            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <vs-avatar size="80" circle history history-gradient badge badge-color="primary">
                    <img :src="url + servicio.terapistaCinco.foto">
                    <template #badge v-if="showPerfil">
						<span @click="openProfile(servicio.terapistaCinco.id)" class="cursor-pointer">
                            Ver perfil
                        </span>
					</template>
                </vs-avatar>
            </el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
                <b>Nombre:</b> {{ servicio.terapistaCinco.nombre }}<br>
                <b>Servicio:</b> {{ masajeCinco }}<br>
                <b>Duración:</b> {{ servicio.duracion }} minutos<br>
                <b>Tipo:</b> {{ servicioTipoNombre }}
            </el-col>
            <el-col :span="24" class="mt-2">
                <el-row class="mb-3">
					<el-col :span="2">
						<vs-checkbox color="#123b5a" v-model="tyc" val="masajeCinco">
						</vs-checkbox>
					</el-col>
					<el-col :span="22">
                        Conozco y acepto <a class="font-weight-normal" target="_blank" :href="urlTyc">TyC</a> de servicios de masajes reservados a domicilio.
					</el-col>
				</el-row>
            </el-col>

        </el-row>

        <el-row class="mb-3">
            <el-divider content-position="center">Detalles del Servicio</el-divider>
        </el-row>

        <el-row>

            <el-col :span="24" class="mb-3">
                <b>Ciudad:</b> {{ nombreCiudad }}<br>
				<b>Dirección:</b> {{ nombreDireccion }}<br>
				<b>Ascensor:</b> {{ nombreAscensor }}<br>
				<b>Parqueadero:</b> {{ nombreParqueadero }}<br>
				<b>Fecha:</b> {{ servicio.fecha }}<br>
				<b>Hora:</b> {{ servicio.hora }}
            </el-col>

            <el-col :offset="4" :span="16">

                <vs-button v-if="!servicio.codigo.valido && !this.servicio.anticipadoValor" block flat @click="modalPromo = !modalPromo">
					Tengo un código
				</vs-button>

				<vs-dialog width="300px" not-center v-model="modalPromo">
					<template #header>
						<p class="not-margin text-center">
							Ingresa tu código
						</p>
					</template>

					<div class="con-content mb-3">
						<vs-input v-model="servicio.codigo.codigoInput" placeholder="Código"></vs-input>
					</div>

					<div class="con-content" v-if="errorCodigo">
						<p class="text-danger">{{ errorCodigo }}</p>
					</div>

					<template #footer>
						<div class="con-footer">
							<vs-button @click="modalPromo = !modalPromo" dark transparent>
								Cancelar
							</vs-button>
							<vs-button flat @click="buscarCodigo()" transparent>
								Validar
							</vs-button>
						</div>
					</template>
				</vs-dialog>

            </el-col>

        </el-row>

        <el-row>
            <el-divider content-position="center">Valor del Servicio</el-divider>
        </el-row>

        <el-row class="mb-3">

            <el-col :span="24" class="mb-3">
				<div v-if="servicio.codigo.valido"><b>Código:</b> {{ servicio.codigo.codigoInput }}
					<el-tooltip class="item" effect="dark" content="Eliminar este código de descuento" placement="top">
						<el-button @click="borrarCodigo()" size="mini" type="danger" icon="el-icon-close" class="btn-limpiar-promo"></el-button>
					</el-tooltip><br>
				</div>
				<div v-if="servicio.codigo.valido"><b>Descuento:</b> {{ descuentoFormat }}<br></div>
                <b>Valor servicio:</b> ${{ valorServicioFormat }}<br>
                <div v-if="servicio.desplazamientoUno"><b>Desplazamiento {{ servicio.terapistaUno.nombre }}:</b> ${{ valorDesplazamientoUno }} <a href="#modalAdicional" data-toggle="modal" data-target="#modalAdicional"><span class="badge badge-comfy badge-danger s-10"><i class="icon-info text-white"></i></span></a><br></div>
                <div v-if="servicio.desplazamientoDos"><b>Desplazamiento {{ servicio.terapistaDos.nombre }}:</b> ${{ valorDesplazamientoDos }} <a href="#modalAdicional" data-toggle="modal" data-target="#modalAdicional"><span class="badge badge-comfy badge-danger s-10"><i class="icon-info text-white"></i></span></a><br></div>
                <div v-if="servicio.desplazamientoTres"><b>Desplazamiento {{ servicio.terapistaTres.nombre }}:</b> ${{ valorDesplazamientoTres }} <a href="#modalAdicional" data-toggle="modal" data-target="#modalAdicional"><span class="badge badge-comfy badge-danger s-10"><i class="icon-info text-white"></i></span></a><br></div>
                <div v-if="servicio.desplazamientoCuatro"><b>Desplazamiento {{ servicio.terapistaCuatro.nombre }}:</b> ${{ valorDesplazamientoCuatro }} <a href="#modalAdicional" data-toggle="modal" data-target="#modalAdicional"><span class="badge badge-comfy badge-danger s-10"><i class="icon-info text-white"></i></span></a><br></div>
                <div v-if="servicio.desplazamientoCinco"><b>Desplazamiento {{ servicio.terapistaCinco.nombre }}:</b> ${{ valorDesplazamientoCinco }} <a href="#modalAdicional" data-toggle="modal" data-target="#modalAdicional"><span class="badge badge-comfy badge-danger s-10"><i class="icon-info text-white"></i></span></a><br></div>
                <div v-if="servicio.datosDireccion.valorParqueadero > 0"><b>Parqueadero:</b> ${{ valorParqueadero }} <a href="#modalParqueadero" data-toggle="modal" data-target="#modalParqueadero"><span class="badge badge-comfy badge-danger s-10"><i class="icon-info text-white"></i></span></a><br></div>
                <div v-if="servicio.datosDireccion.valorAscensor > 0"><b>Ascensor:</b> ${{ valorAscensor }} <a href="#modalAscensor" data-toggle="modal" data-target="#modalAscensor"><span class="badge badge-comfy badge-danger s-10"><i class="icon-info text-white"></i></span></a><br></div>
                <div v-if="servicio.tarifaDinamica"><b>Tarifa dinámica:</b> ${{ valorTarifaDinamica }} <a href="#modalTarifadinamica" data-toggle="modal" data-target="#modalTarifadinamica"><span class="badge badge-comfy badge-danger s-10"><i class="icon-info text-white"></i></span></a><br></div>
                <div v-if="servicio.anticipadoValor"><b>Descuento por reserva anticipada:</b> ${{ valorAnticipo }} <a href="#modalAnticipado" data-toggle="modal" data-target="#modalAnticipado"><span class="badge badge-comfy badge-danger s-10"><i class="icon-info text-white"></i></span></a><br></div>
				<div v-if="servicio.codigo.valido"><b>Valor con descuento:</b> ${{ descuentoNetoFormat }}<br></div>
                <div v-if="cliente.saldo"><b>Comfy Crédito Disponible:</b> ${{ saldoFormat }}{{ (saldoFormat > 0) ? ', se usará para abonar al servicio' : '' }}<br></div>
				<b>TOTAL POR PAGAR:</b> ${{ valorNetoServicio }}
            </el-col>

        </el-row>

        <!-- Modal adicional -->
        <div class="modal fade" id="modalAdicional" tabindex="-1" role="dialog" aria-labelledby="myModalAdicional">
            <div class="modal-dialog" role="document" style="max-width: 400px;">
                <div class="modal-content no-r"><a href="#" data-dismiss="modal" aria-label="Close" class="paper-nav-toggle active"><i></i></a>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="text-center p-md-4 p-sm-2 p-b-0">
                                    <img :src="path + '/frontend/img/comfy/v2/comfy_logotipo_azul.png'" alt="">
                                    <p class="p-t-b-20 font-weight-bold p-t-b-20 font-weight-bold mb-0 mt-4">¿Por qué hay un Adicional por Cobertura?</p>
                                    <p class="p-t-b-20">Porque las PRO Comfy tienen zonas de cobertura predefinidas por cercanía o facilidad para movilizarse. Si tu dirección está por fuera de las zonas de cobertura de la PRO que quieres escoger, se genera un valor adicional por metro. Ese costo va directamente a la PRO.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal tarifa dinámica -->
        <div class="modal fade" id="modalTarifadinamica" tabindex="-1" role="dialog" aria-labelledby="myModalTarifadinamica">
            <div class="modal-dialog" role="document" style="max-width: 400px;">
                <div class="modal-content no-r"><a href="#" data-dismiss="modal" aria-label="Close" class="paper-nav-toggle active"><i></i></a>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="text-center p-md-4 p-sm-2 p-b-0">
                                    <img :src="path + '/frontend/img/comfy/v2/comfy_logotipo_azul.png'" alt="">
                                    <p class="p-t-b-20 font-weight-bold p-t-b-20 font-weight-bold mb-0 mt-4">¿Por qué existe una tarifa dinámica?</p>
                                    <p class="p-t-b-20">Porque las condiciones para la prestación del servicio en algunas horas del día pueden representar un costo variable para nuestras PRO.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal descuento anticipado -->
        <div class="modal fade" id="modalAnticipado" tabindex="-1" role="dialog" aria-labelledby="myModalAnticipado">
            <div class="modal-dialog" role="document" style="max-width: 400px;">
                <div class="modal-content no-r"><a href="#" data-dismiss="modal" aria-label="Close" class="paper-nav-toggle active"><i></i></a>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="text-center p-md-4 p-sm-2 p-b-0">
                                    <img :src="path + '/frontend/img/comfy/logo-dark.png'" alt="">
                                    <p class="p-t-b-20 font-weight-bold p-t-b-20 font-weight-bold mb-0 mt-4">¿Por qué existe éste descuento?</p>
                                    <p class="p-t-b-20">
                                        Si reservas con {{ this.servicio.anticipadoHoras }} horas o más de anticipación, Comfy te regala el {{ this.servicio.anticipadoPorcentaje }}% de descuento ;)
                                        <br>
                                        Éste descuento <b>NO</b> aplica para el desplazamiento adicional, códigos de descuento y/o tarifa dinámica, únicamente para el valor del servicio.
                                        </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Parqueadero -->
        <div class="modal fade" id="modalParqueadero" tabindex="-1" role="dialog" aria-labelledby="myModalParqueadero">
            <div class="modal-dialog" role="document" style="max-width: 400px;">
                <div class="modal-content no-r"><a href="#" data-dismiss="modal" aria-label="Close" class="paper-nav-toggle active"><i></i></a>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="text-center p-md-4 p-sm-2 p-b-0">
                                    <p class="p-t-b-20 font-weight-bold p-t-b-20 font-weight-bold mb-0 mt-4">¿Por qué hay un adicional por parqueadero?</p>
                                    <p class="p-t-b-20">Este extra va directamente a l@s PROS. Ell@s necesitan un lugar seguro para parquear mientras cumplen tu reserva.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Ascensor -->
        <div class="modal fade" id="modalAscensor" tabindex="-1" role="dialog" aria-labelledby="myModalAscensor">
            <div class="modal-dialog" role="document" style="max-width: 400px;">
                <div class="modal-content no-r"><a href="#" data-dismiss="modal" aria-label="Close" class="paper-nav-toggle active"><i></i></a>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="text-center p-md-4 p-sm-2 p-b-0">
                                    <p class="p-t-b-20 font-weight-bold p-t-b-20 font-weight-bold mb-0 mt-4">¿Por qué hay un adicional por ascensor?</p>
                                    <p class="p-t-b-20">Esta información es trascendental para l@s PROS porque pueden definir a qué servicios acudir y a cuales no dada la dificultad de acceder a tu espacio.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

	</div>

</template>

<script>
    import 'boxicons';
    import 'boxicons/css/boxicons.min.css';
	export default {
		components: {},
        props: [
            'servicio',
            'cliente',
            'path'
        ],
        data() {
            return {
                url: 'https://ivo-comfy.s3.amazonaws.com/',
                masajeUno: '',
                masajeDos: '',
                masajeTres: '',
                masajeCuatro: '',
                masajeCinco: '',
                servicioTipoNombre: '',
                nombreCiudad: '',
                nombreDireccion: '',
                nombreAscensor: '',
                nombreParqueadero: '',
                modalPromo: false,
                errorCodigo: '',
                tyc: [],
                urlTyc: '',
                cantidadMasajes: 0,
                showPerfil: true,
            }
        },
        computed: {
            saldoFormat: function(){
                return new Intl.NumberFormat().format(this.cliente.saldo)
                // return this.cliente.saldo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            valorServicioFormat: function(){
                const precio = this.servicio.precio - this.servicio.desplazamiento - this.servicio.tarifaDinamica
                return new Intl.NumberFormat().format(precio)
            },
            valorDesplazamientoUno: function(){
                return new Intl.NumberFormat().format(this.servicio.desplazamientoUno)
            },
            valorDesplazamientoDos: function(){
                return new Intl.NumberFormat().format(this.servicio.desplazamientoDos)
            },
            valorDesplazamientoTres: function(){
                return new Intl.NumberFormat().format(this.servicio.desplazamientoTres)
            },
            valorDesplazamientoCuatro: function(){
                return new Intl.NumberFormat().format(this.servicio.desplazamientoCuatro)
            },
            valorDesplazamientoCinco: function(){
                return new Intl.NumberFormat().format(this.servicio.desplazamientoCinco)
            },
            valorTarifaDinamica: function(){
                return new Intl.NumberFormat().format(this.servicio.tarifaDinamica)
            },
            valorAnticipo: function(){
                return new Intl.NumberFormat().format(this.servicio.anticipadoValor)
            },
            valorParqueadero: function(){
                let multiplo = 1
                if(this.servicio.tipo == 'doble'){
                    multiplo = parseInt(this.servicio.grupal)
                }
                this.servicio.precioParqueadero = this.servicio.datosDireccion.valorParqueadero * multiplo
                return new Intl.NumberFormat().format(this.servicio.datosDireccion.valorParqueadero * multiplo)
            },
            valorAscensor: function(){
                let multiplo = 1
                if(this.servicio.tipo == 'doble'){
                    multiplo = parseInt(this.servicio.grupal)
                }
                this.servicio.precioAscensor = this.servicio.datosDireccion.valorAscensor * multiplo
                return new Intl.NumberFormat().format(this.servicio.datosDireccion.valorAscensor * multiplo)
            },
            descuentoFormat: function(){
                let descuento = this.servicio.codigo.descuento
                if(this.servicio.codigo.tipoUso == 'porcentaje'){
                    let servicioDescuento = ((this.servicio.precio * this.servicio.codigo.descuento) / 100).toFixed()
                    return descuento + '% equivalente a $' + new Intl.NumberFormat().format(servicioDescuento)
                }
                return '$' + new Intl.NumberFormat().format(descuento)
                // return this.servicio.codigo.descuento.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            descuentoNetoFormat: function(){
                // let descuento = this.servicio.codigo.descuento
                if(this.servicio.codigo.tipoUso == 'porcentaje'){
                    let servicioDescuento = ((this.servicio.precio * this.servicio.codigo.descuento) / 100).toFixed()
                    let descuentoneto = this.servicio.precio - servicioDescuento
                    return descuentoneto.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }
                let descuentoneto = this.servicio.precio - this.servicio.codigo.descuento
                return descuentoneto.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            valorNetoServicio: function(){
                let saldo = this.cliente.saldo
                let precio = this.servicio.precio
                // let dinamica = this.servicio.tarifaDinamica
                let descuento = 0
                let parqueadero = this.servicio.precioParqueadero
                let ascensor = this.servicio.precioAscensor
                if(this.servicio.codigo.valido){
                    descuento = this.servicio.codigo.descuento
                    if(this.servicio.codigo.tipoUso == 'porcentaje'){
                        descuento = ((this.servicio.precio * this.servicio.codigo.descuento) / 100).toFixed()
                        // console.log(descuento)
                        // descuento = new Intl.NumberFormat().format(descuentoTemporal)
                    }
                }
                let anticipado = 0
                this.servicio.anticipadoValor = 0
                if(this.servicio.horas > this.servicio.anticipadoHoras && saldo < 1){
                    this.borrarCodigo()
                    anticipado = parseInt(((((this.servicio.precio - this.servicio.desplazamiento) * this.servicio.anticipadoPorcentaje)) / 100).toFixed())
                    this.servicio.anticipadoValor = anticipado
                    descuento = 0
                }
                let neto = precio + parqueadero + ascensor - saldo - descuento - anticipado
                if(neto <= 0){
                    neto = '0'
                }
                let netoServicio = precio + parqueadero + ascensor - descuento - anticipado

                EventBus.$emit('actualizarPrecio', neto)
                return new Intl.NumberFormat().format(netoServicio)
            },
        },
        watch: {
            tyc: function(){
                if(this.tyc.length == this.cantidadMasajes) {
                    EventBus.$emit('bloquearSiguiente', true)
                }else{
                    EventBus.$emit('bloquearSiguiente', false)
                }
            }
        },
        methods: {
            nombreMasajeUno(){
                if(this.servicio.tipo != 'sencillo'){
                    this.nombreMasajeDos()
                }
                var url = '/cliente/consultar-variables'
                axios.post(url, {
                    'masaje_id': this.servicio.masaje_uno,
                }).then(response => {
                    if(response.data.code == 200){
                        this.masajeUno = response.data.masaje_nombre
                    }
                })
            },
            nombreMasajeDos(){
                var url = '/cliente/consultar-variables'
                axios.post(url, {
                    'masaje_id': this.servicio.masaje_dos,
                }).then(response => {
                    if(response.data.code == 200){
                        this.masajeDos = response.data.masaje_nombre
                    }
                })
            },
            nombreMasajeTres(){
                var url = '/cliente/consultar-variables'
                axios.post(url, {
                    'masaje_id': this.servicio.masaje_tres,
                }).then(response => {
                    if(response.data.code == 200){
                        this.masajeTres = response.data.masaje_nombre
                    }
                })
            },
            nombreMasajeCuatro(){
                var url = '/cliente/consultar-variables'
                axios.post(url, {
                    'masaje_id': this.servicio.masaje_cuatro,
                }).then(response => {
                    if(response.data.code == 200){
                        this.masajeCuatro = response.data.masaje_nombre
                    }
                })
            },
            nombreMasajeCinco(){
                var url = '/cliente/consultar-variables'
                axios.post(url, {
                    'masaje_id': this.servicio.masaje_cinco,
                }).then(response => {
                    if(response.data.code == 200){
                        this.masajeCinco = response.data.masaje_nombre
                    }
                })
            },
            datosDireccion(){
                if(this.servicio.datosDireccion.ascensor == 'no'){
                    this.nombreAscensor = 'No tengo'
                }else if(this.servicio.datosDireccion.ascensor == 'no_necesario'){
                    this.nombreAscensor = 'No es necesario'
                }else if(this.servicio.datosDireccion.ascensor == 'si'){
                    this.nombreAscensor = 'Si tengo'
                }
                if(this.servicio.datosDireccion.parqueadero == 'no'){
                    this.nombreParqueadero = 'No tengo'
                }else if(this.servicio.datosDireccion.parqueadero == 'si'){
                    this.nombreParqueadero = 'Si tengo'
                }
            },
            nombreCiudadDireccion(){
                var url = '/cliente/consultar-variables'
                axios.post(url, {
                    'direccion_id': this.servicio.datosDireccion.direccion,
                }).then(response => {
                    if(response.data.code == 200){
                        this.cliente.saldo = response.data.saldo
                        this.nombreCiudad = response.data.ciudad
                        this.nombreDireccion = response.data.direccion
                    }
                })
            },
            servicioTipo(){
                if(this.servicio.tipo == 'btb'){
                    this.servicioTipoNombre = 'Back to Back'
                }else if(this.servicio.tipo == 'doble'){
                    this.servicioTipoNombre = 'Doble'
                }else{
                    this.servicioTipoNombre = 'Sencillo'
                }
            },
            buscarCodigo(){
                this.errorCodigo = ''
                this.servicio.codigo.valido = false
                if(!this.servicio.codigo.codigoInput){
                    this.errorCodigo = 'Debes ingresar un código para consultar disponibilidad.'
                    return
                }
                var url = '/cliente/buscar-codigo'
                axios.post(url, {
                    'codigo': this.servicio.codigo.codigoInput,
                    'horas': this.servicio.horas,
                    'ciudad': this.servicio.ciudad,
                }).then(response => {
                    if(response.data.code == 200){
                        this.modalPromo = false
                        this.servicio.codigo.codigoInput = response.data.codigo
                        this.cliente.saldo = response.data.saldo
                        this.servicio.codigo.tipo = response.data.tipo
                        this.servicio.codigo.tipoUso = response.data.tipoUso
                        this.servicio.codigo.descuento = response.data.valor
                        this.servicio.codigo.valido = true
                        if(response.data.tipo == 'giftCard'){
                            this.servicio.codigo.valido = false
                        }
                    }else if(response.data.code == 400){
                        this.errorCodigo = response.data.mensaje
                        this.servicio.codigo.descuento = ''
                        this.servicio.codigo.tipo = ''
                        this.servicio.codigo.codigoInput = ''
                        this.servicio.codigo.valido = false
                    }
                })
            },
            borrarCodigo(){
                this.servicio.codigo.codigoInput = ''
                this.servicio.codigo.valido = false
                this.servicio.codigo.descuento = ''
                this.servicio.codigo.tipo = ''
            },
            calcularInicioServicio(){
                var fechaServicio = new Date(this.servicio.fecha + ' ' + this.servicio.hora)
                var fechaActual = new Date()
                this.servicio.horas = ((fechaServicio - fechaActual) / (1000 * 3600)).toFixed()
                // console.log(this.servicio.horas)
                // console.log(this.servicio)
            },
            bloquearSiguiente(){
                EventBus.$emit('bloquearSiguiente', false);
                if(this.servicio.masaje_uno) this.cantidadMasajes++
                if(this.servicio.masaje_dos) this.cantidadMasajes++
                if(this.servicio.masaje_tres) this.cantidadMasajes++
                if(this.servicio.masaje_cuatro) this.cantidadMasajes++
                if(this.servicio.masaje_cinco) this.cantidadMasajes++
            },
            urlTerminosCondiciones(){
                var url = '/cliente/url-tyc'
                axios.get(url).then(response => {
                    this.urlTyc = response.data
                }).catch(error => {
                    console.log(error)
                    this.urlTyc = '/terminos-y-condiciones'
                })
            },
            openProfile(id){
                EventBus.$emit('consultarPerfil', id);
            }
        },
        mounted() {
            // console.log('--- resumen component mounted ---')
            this.nombreMasajeUno()
            this.servicioTipo()
            this.nombreCiudadDireccion()
            this.datosDireccion()
            this.calcularInicioServicio()
            this.urlTerminosCondiciones()
            if(this.servicio.tipo != 'sencillo'){
                this.nombreMasajeDos()
            }
            if(this.servicio.grupal > 2){
                this.nombreMasajeTres()
            }
            if(this.servicio.grupal > 3){
                this.nombreMasajeCuatro()
            }
            if(this.servicio.grupal > 4){
                this.nombreMasajeCinco()
            }
            setTimeout(() => this.bloquearSiguiente(), 500)
        }
    };

</script>

<style>
	.vs-avatar-content.history--gradient:after{
		background-image: linear-gradient(40deg, #429eff 0%, #123b5a 100%) !important;
	}
	.not-margin {
        margin: 0;
        font-weight: 400;
        padding: 10px 10px 0;
	}
	.con-content .vs-input-content .vs-input {
        width: 100%;
    }
    .con-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .el-button--mini, .el-button--mini.is-round {
        padding: 2px 3px;
        font-size: 10px;
        border-radius: 4px;
        vertical-align: middle;
	}
    .avatar-right{
        float: right;
        position: relative;
    }
    .vs-avatar-content.history.avatar-right .vs-avatar{
        margin-top: 0px;
    }
    .btn-limpiar-promo {
        padding: 2px !important;
    }
    .vs-button__content{
        font-size: 17px !important;
    }
    .vs-button--flat {
        background: #cddae0 !important;
        color: #18333d !important;
    }
    .vs-button--flat:hover {
        background: #18333d !important;
        color: #cddae0 !important;
    }
    .el-divider__text.is-center {
        left: 45%;
        -webkit-transform: translateX(-45%) translateY(-50%);
        transform: translateX(-45%) translateY(-50%);
    }
    .vs-avatar__icons{
        min-height: auto;
    }
    .vs-avatar-content--circle .vs-avatar__badge {
        left: -2px;
        bottom: -2px;
    }
</style>